import * as tslib_1 from "tslib";
// Core components
import { AfterViewInit, OnDestroy } from "@angular/core";
// Third party components
import { ActivatedRoute } from '@angular/router';
import { FieldType } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { CondoStructuresService } from 'src/app/modules/properties/condo-structures.service';
// Custom components
var SelectElectricMeterTypeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SelectElectricMeterTypeComponent, _super);
    function SelectElectricMeterTypeComponent(condoStructuresService, translateService, activatedRoute) {
        var _this = _super.call(this) || this;
        _this.condoStructuresService = condoStructuresService;
        _this.translateService = translateService;
        _this.activatedRoute = activatedRoute;
        _this.subscriptions = [];
        _this.items = [];
        return _this;
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    SelectElectricMeterTypeComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var condoStructureId = this.activatedRoute.snapshot.params.mappingFormActiveSection
            .split("/")[1];
        this.subscriptions.push(this.condoStructuresService
            .getCondoStructuresListForElectricMeter(condoStructureId)
            .subscribe(function (res) {
            if (res.status) {
                var items = Array.isArray(res.data.items)
                    ? res.data.items
                    : Array.isArray(res.data)
                        ? res.data
                        : [];
                if (Array.isArray(items)) {
                    items.forEach(function (item) {
                        if (Array.isArray(item.values)) {
                            item.values.forEach(function (subItem) {
                                subItem.nome = subItem.nome.charAt(0).toUpperCase() + subItem.nome.slice(1).toLowerCase();
                            });
                        }
                    });
                }
                _this.items = items;
            }
        }));
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    SelectElectricMeterTypeComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    return SelectElectricMeterTypeComponent;
}(FieldType));
export { SelectElectricMeterTypeComponent };
